const NAME = 'config'

export {
  NAME
}
